// https://stackoverflow.com/questions/56934826/distinguish-between-ipad-and-mac-on-ipad-with-ipados
export default (navigator = window.navigator) =>
  /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
  (navigator.maxTouchPoints
    ? navigator.userAgent.toLowerCase().indexOf("macintosh") > -1 &&
      navigator.maxTouchPoints > 2
    : false)
